export default __webpack_public_path__ + "static/media/stripes.9ce547b3.svg";